export const defaultClientAllSelector = (state) =>
  state?.defaultClientReducer?.defaultClientAll;
export const defaultClientOpenAddSelector = (state) =>
  state?.defaultClientReducer?.defaultClientOpenAdd;
export const defaultClientOpenEditSelector = (state) =>
  state?.defaultClientReducer?.defaultClientOpenEdit;
export const defaultClientSelectedSelector = (state) =>
  state?.defaultClientReducer?.defaultClientSelected;
export const defaultClientSearchSelector = (state) =>
  state?.defaultClientReducer?.defaultClientSearch;
//
export const defaultClientInfoSelector = (state) =>
  state?.defaultClientReducer?.defaultClientInfo;
export const defaultClientTypeSelector = (state) =>
  state?.defaultClientReducer?.defaultClientType;
export const defaultClientDetailSelector = (state) =>
  state?.defaultClientReducer?.defaultClientDetail;
//KYC
export const defaultClientStepSelector = (state) =>
  state?.defaultClientReducer?.defaultClientStep;
